import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core';
import { MoneyValue, NoValue } from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  skeletonWrapper: {
    width: '100%'
  }
}));

export const AmountRenderer = ({
  field,
  record,
  className,
  column: { isLineItemUpdating }
}) => {
  const classes = useStyles();
  const money = record[field];

  if (isLineItemUpdating)
    return (
      <div className={classes.skeletonWrapper}>
        <Skeleton variant="text" width="100%" height={24} />
      </div>
    );

  return money ? (
    <MoneyValue dataQeId={record?.id} money={money} className={className} />
  ) : (
    <NoValue />
  );
};

AmountRenderer.propTypes = {
  field: PropTypes.string,
  record: PropTypes.object,
  className: PropTypes.string,
  column: PropTypes.object
};
export default AmountRenderer;
